var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-toggle"},[_c('span',{staticClass:"toggle-element",class:{ enabled: _vm.toggleValue },on:{"click":_vm.toggle}},[_c('span',{staticClass:"inner"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }